module.exports = __webpack_public_path__ + "img/giostrina-animali.6f9724b3.jpg";